"use client"
import "./WhatsAppButton.css"

const WhatsAppButton = () => {
    const phoneNumber = "542216973030"
    const message = "Hola Contactame! Tengo una consulta..."

    const handleWhatsAppClick = () => {
        const encodedMessage = encodeURIComponent(message)
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
        window.open(whatsappUrl, "_blank")
    }

    return (
        <button className="whatsapp-floating-button" onClick={handleWhatsAppClick} aria-label="Contactar por WhatsApp">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175.216 175.552" width="28" height="28" fill="#ffffff">
                <path d="M147.934,27.58C131.3,9.818,108.487,0,83.693,0a87.3,87.3,0,0,0-87.6,87.02,87.537,87.537,0,0,0,11.729,43.51L0,175.552l46.24-12.108a87.723,87.723,0,0,0,37.453,9.568h.035a87.3,87.3,0,0,0,87.6-87.02C171.293,61.2,164.568,45.343,147.934,27.58ZM83.693,159.232a72.962,72.962,0,0,1-37.221-10.191l-2.667-1.583L18.93,155.021l7.815-23.076-1.735-2.763A72.716,72.716,0,0,1,13.881,87.02,72.611,72.611,0,0,1,83.693,14.78c20.642,0,39.553,8.056,53.462,22.7,13.909,14.648,21.557,34.106,21.557,54.763A72.608,72.608,0,0,1,83.693,159.232Z" />
                <path d="M61.21,49.136l-6.1-.139a7.131,7.131,0,0,0-5.174,2.16,21.86,21.86,0,0,0-6.8,16.264c.139,9.568,6.1,18.772,6.938,20.078a84.659,84.659,0,0,0,32.626,31.32c16.125,7.815,19.38,6.243,22.9,5.87s11.268-4.626,12.87-9.082,1.6-8.3,1.118-9.082-1.735-1.3-3.609-2.3-11.268-5.522-12.87-6.173-3.013-1.048-4.287.9-4.844,6.173-5.939,7.408-2.226,1.3-4.1.3-7.955-2.9-15.125-9.29a56.466,56.466,0,0,1-10.4-12.943c-1.1-1.874-.139-2.9.826-3.826,1.874-1.874,4.1-4.844,6.1-7.269a3.353,3.353,0,0,0,.139-3.826c-.413-1.048-4.287-10.33-5.87-14.125C63.3,50.184,62.178,49.136,61.21,49.136Z" />
            </svg>
        </button>
    )
}

export default WhatsAppButton

